import React, { useContext } from 'react';
import EDButton from '../../../../../../../BaseComponents/Buttons/Button/EDButton';
import EDIconButton from '../../../../../../../BaseComponents/Buttons/IconButton/EDIconButton';
import EDIcon from '../../../../../../../BaseComponents/Icon/EDIcon';
import {
  TEDEKBokforderRadKONT_USE_ROWEnum,
  TEDEKBokforderSTATUSEnum,
} from '../../../../../../../globalQueryTypes';
import { useIsSmallScreen } from '../../../../../../../Hooks/useFullscreenView';
import { BusinessDataFormContext } from '../../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/BusinessDataForm';
import { BokforderType__Associations_Rader } from '../../Queries/_QueryTypes/BokforderType';

interface IProps {
  onClick: () => void;
}

const statuses = [TEDEKBokforderSTATUSEnum.VERIFIKATION_SKAPAD];

const ShowBFOBokfKonteringarButton: React.FC<IProps> = props => {
  const formContext = useContext(BusinessDataFormContext);
  const isSmallScreen = useIsSmallScreen();

  return (
    <>
      {statuses.some(status => status === formContext?.data?.STATUS) &&
        formContext?.formState.currentValues?._Associations?.Rader?.some(
          (row: BokforderType__Associations_Rader) =>
            (row.BokfortAvvikande === 'Y' || row.BokfortAvvikande === 'S') &&
            row.KONT_USE_ROW === TEDEKBokforderRadKONT_USE_ROWEnum.JA
        ) && (
          <>
            {isSmallScreen ? (
              <EDIconButton
                color="primary"
                icon="inventory"
                margin="dense"
                onClick={props.onClick}
                padding="dense"
                tooltip="Visa bokförda konteringar"
              />
            ) : (
              <EDButton
                flat
                label="Visa bokförda konteringar"
                icon={<EDIcon color="primary" iconType="inventory" />}
                onClick={props.onClick}
              />
            )}
          </>
        )}
    </>
  );
};

export default ShowBFOBokfKonteringarButton;
